<div class="access-selection-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">
            <mat-icon class="title-icon">{{ hasAtLeastOneAccess() ? 'domain' : 'warning' }}</mat-icon>
            {{ getDialogTitle() }}
        </h2>
        <p class="dialog-subtitle">{{ getDialogMessage() }}</p>
    </div>

    <div class="dialog-content">
        <!-- Accesses available for selection -->
        <div *ngIf="hasAtLeastOneAccess()" class="accesses-selection">
            <div class="accesses-list">
                <div *ngFor="let access of accesses" class="access-option"
                    [class.selected]="selectedAccessId === access.id" (click)="onAccessSelect(access.id)">

                    <div class="access-radio">
                        <mat-radio-button [value]="access.id" [checked]="selectedAccessId === access.id"
                            (change)="onAccessSelect(access.id)" color="primary">
                        </mat-radio-button>
                    </div>

                    <div class="access-info">
                        <div class="access-main">
                            <span class="access-name">{{ access.denumire_directie }}</span>
                            <span *ngIf="access.denumire_compartiment" class="access-subname">{{
                                access.denumire_compartiment }}</span>
                        </div>

                        <div class="access-status d-flex flex-row align-items-center gap-2" *ngIf="access.active">
                            <mat-icon>check_circle</mat-icon>
                            <span>Activă curent</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="selection-info">
                <mat-icon class="info-icon">info</mat-icon>
                <span>Direcția activă va fi utilizată în cadrul aplicației.</span>
            </div> -->
        </div>

        <!-- No accesses available -->
        <div *ngIf="!hasAtLeastOneAccess()" class="no-accesses-message">
            <div class="no-accesses-content">
                <mat-icon class="warning-icon">warning_amber</mat-icon>
                <h3>Nicio direcție și compartiment disponibile</h3>
                <p>
                    Nu aveți direcții și compartimente alocate în sistem. Pentru a putea utiliza aplicația,
                    trebuie să contactați administratorul pentru a vă asigna cel puțin o direcție.
                </p>
                <div class="contact-info">
                    <mat-icon>contact_support</mat-icon>
                    <span>Contactați administratorul sistemului</span>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-actions">
        <div class="action-buttons">
            <button *ngIf="canCancel()" class="btn btn-light" type="button" mat-flat-button (click)="closeDialog()"
                [disabled]="isLoading">
                <mat-icon>close</mat-icon>
                Anulare
            </button>

            <button *ngIf="hasAtLeastOneAccess()" class="btn btn-primary" type="button" mat-flat-button color="primary"
                (click)="onConfirm()" [disabled]="!selectedAccessId || isLoading">
                <mat-icon *ngIf="!isLoading">check</mat-icon>
                <mat-spinner *ngIf="isLoading" diameter="20"></mat-spinner>
                {{ isLoading ? 'Se confirmă...' : 'Confirmă selecția' }}
            </button>
        </div>
    </div>

    <!-- Loading overlay -->
    <div class="loading-overlay" *ngIf="isLoading">
        <div class="spinner-container">
            <mat-spinner diameter="50"></mat-spinner>
            <h3 class="mt-2">Se setează accesul activ...</h3>
        </div>
    </div>
</div>